import {
    Box,
    Grid,
    Typography,
    Skeleton,
    Card,
    Divider
} from '@mui/material'
import SearchBar from '../../components/ui/SearchBar'
import AppStateSelect from '../../components/ui/AppStateSelect'
import { useEffect } from 'react'
import React, { useState, useRef, useCallback } from 'react'
import { GoogleMap, useJsApiLoader, Marker, OverlayViewF, OVERLAY_MOUSE_TARGET } from '@react-google-maps/api'
import axios from 'axios'
import { OurDearUrl } from '../../common/url'
import InfiniteScroll from 'react-infinite-scroll-component'
import MapICON from '../../assets/map-marker/map_marker.png'
import { Empty } from 'antd'
import { isTablet } from 'react-device-detect'
import MapHighLightICON from '../../assets/map-marker/map_maker_highlight.png'
// import { useCurrentLocation } from '../../components/ui/MapView/context'

const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '10px',
}

export const SMAppOurDealer: React.FC = () => {

    const [zoom, setZoom] = useState(8)

    const [isLoadMap, setIsLoadMap] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)

    const [pageCount, setPageCount] = useState(1)

    const scrollRef = useRef()

    // const mapRef = useRef()

    const [searchText, setSearchText] = useState('')

    const [stateText, setStateText] = useState('')

    const [makerText, setMakerText] = useState('')

    const [mapInstance, setMapInstance] = useState<google.maps.Map>()

    const [currentId, setCurrentId] = useState(-1)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyDpRhUxHc-FK0hWoIf8VeSSoIZDEPwQ3-A',
    })

    const [center, setCenter] = useState({
        lat: 3.12,
        lng: 101.70,
    })

    const [data, setData] = useState(null)

    const [mapData, setMapData] = useState(null)

    const skeletonData = ['', '', '', '', '', '']

    const [overlayData, setOverlayData] = useState(null)

    const skeletonItem = (index: number) => {
        return (
            <Grid item key={index} xs={isTablet ? 6 : 12}>
                <Box>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                </Box>
            </Grid>
        )
    }

    useEffect(() => {
        if (navigator.geolocation && isLoadMap === false) {
            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    setIsLoadMap(true)
                    setCenter({ lat: position.coords.latitude, lng: position.coords.longitude })
                },
                (positionError: GeolocationPositionError) => {

                }
            )
        } else {
            console.log('不支持定位')
        }

        ; (async () => {
            await fetchList(false)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText, stateText, makerText])

    const fetchList = async (isMore: boolean) => {
        try {
            const page = isMore ? currentPage + 1 : 1
            var url = OurDearUrl + '?pagination[page]=' + page + '&pagination[pageSize]=25&sort=sequence:ASC&publicationState=live'
            if (searchText !== null && searchText.length > 0) {
                url = url + '&filters[dearName][$contains]=' + searchText
            }
            if (stateText !== null && stateText.length > 0) {
                url = url + '&filters[state][$eq]=' + stateText
            }
            if (makerText !== null && makerText.length > 0) {
                url = url + '&filters[maps][$eq]=' + makerText
            }
            const response = await axios.get(url)
            if (response.status === 200) {
                if (isMore) {
                    setCurrentPage(response.data['meta']['pagination']['page'])
                    setPageCount(response.data['meta']['pagination']['pageCount'])
                    setData([...data, ...response.data['data']])
                    if (makerText === null || makerText === '') {
                        setMapData([...mapData, ...response.data['data']])
                    }
                } else {
                    setCurrentPage(response.data['meta']['pagination']['page'])
                    setPageCount(response.data['meta']['pagination']['pageCount'])
                    setData(response.data['data'])
                    if (makerText === null || makerText === '') {
                        setMapData(response.data['data'])
                    }
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const loadMoreData = async () => {
        if (currentPage < pageCount) {
            fetchList(true)
        }
    }

    const clearAction = () => {
        setStateText('')
    }

    const onLoadMap = useCallback((instance: google.maps.Map) => {
        setMapInstance(instance)
    }, [])

    // const clearMakerText = () => {
    //     setMakerText('')
    // }

    const makerAction = (index: number) => {
        setOverlayData(mapData[index])
        setMakerText(mapData[index]['attributes']['maps'])
        setCenter({ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) })
        mapInstance?.panTo({ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) })
        mapInstance?.setZoom(18)
        setZoom(18)
    }

    const updateCurrentId = (id: number) => {
        setCurrentId(id)
    }

    const clearMarker = () => {
        if (makerText !== null && makerText !== '') {
          setCurrentId(-1)
          setOverlayData(null)
          setMakerText('')
          setCenter({
            lat: 3.12,
            lng: 101.70,
          })
          mapInstance?.setZoom(8)
          setZoom(8)
        }
      }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingTop: '60px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column'
        }}>

            {/* list */}
            <Box sx={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* header:search、select*/}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingBottom: '60px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    <SearchBar
                        onChange={(e) => {
                            clearMarker()
                            setSearchText(e.target.value)
                        }}
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root.Mui-focused': {
                                '& > fieldset': {
                                    borderColor: '#E4E7ED',
                                },
                            },
                            '& .MuiOutlinedInput-root:hover': {
                                '& > fieldset': {
                                    borderColor: '#E4E7ED',
                                },
                            },
                        }}
                        inputProps={{
                            sx: {
                                '&::placeholder': {
                                    color: '#D1D5DB',
                                },
                            },
                        }}
                    />

                    <Box sx={{
                        height: '20px',
                    }}></Box>

                    <AppStateSelect
                        onChange={(e) => {
                            clearMarker()
                            console.log('state===' + e)
                            setStateText(e)
                        }}
                        clearAction={clearAction}
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root.Mui-focused': {
                                '& > fieldset': {
                                    borderColor: '#E4E7ED',
                                },
                            },
                            '& .MuiOutlinedInput-root:hover': {
                                '& > fieldset': {
                                    borderColor: '#E4E7ED',
                                },
                            },
                        }}
                        inputProps={{
                            sx: {
                                '&::placeholder': {
                                    color: '#D1D5DB',
                                },
                            },
                        }}
                    />
                </Box>

                {/* map */}
                <Box sx={{
                    width: '100%',
                    height: '400px',
                    backgroundColor: '#F2F2F2'
                }}>
                    {isLoaded ? (
                        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={zoom} onLoad={onLoadMap}
                            options={{
                                mapTypeControl: true,
                                mapTypeControlOptions: {
                                    position: google.maps.ControlPosition.TOP_RIGHT,
                                },
                                streetViewControl: true,
                                fullscreenControl: true,
                                // default hide all poi and prevent keyboard action, can be overwritten by mapProps
                                keyboardShortcuts: true,
                                styles: [
                                    {
                                        featureType: 'poi',
                                        elementType: 'labels',
                                        stylers: [{ visibility: 'off' }],
                                    },
                                ],
                            }}
                        >
                            {/* Child components, such as markers, info windows, etc. */}
                            {mapData === null ? (
                                <></>
                            ) : (
                                mapData.map((item, index) => (
                                    mapData[index]['attributes']['maps'] !== null && String(mapData[index]['attributes']['maps']).includes(',') ?
                                        <Marker
                                            key={index}
                                            icon={currentId === mapData[index]['id'] ? MapHighLightICON : MapICON}
                                            position={{ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) }}
                                            title={mapData[index]['attributes']['dearName']}
                                            onClick={() => makerAction(index)}
                                        ></Marker>
                                        :
                                        null
                                ))
                            )}
                            {overlayData === null ? null : (<OverlayViewF position={center} mapPaneName={OVERLAY_MOUSE_TARGET} getPixelPositionOffset={{ x: 10, y: 6 }}>
                                <Box sx={{ paddingLeft: '16px', paddingRight: '16px', paddingBottom: '16px', width: '244px', backgroundColor: '#FFFFFF', boxShadow: '0px 10px 80px 3px #0000001A', borderRadius: '8px', transform: 'translateX(-110%) translateY(-60%)' }}>
                                    <Card style={{
                                        borderRadius: '4px',
                                        boxShadow: 'none',
                                        border: 'none',
                                        '&:hover': {
                                            boxShadow: '0px 10px 30px 3px #0000001A',
                                        }
                                    }}>
                                        <div dangerouslySetInnerHTML={{ __html: overlayData['attributes']['image'] }} style={{ minHeight: '150px', borderRadius: '4px' }} />
                                    </Card>

                                    <Box
                                        sx={{
                                            paddingTop: '24px',
                                        }}
                                    >
                                        <Typography fontSize={20} fontWeight={700} color={'#141F39'}>
                                            {overlayData['attributes']['dearName']}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            paddingTop: '10px',
                                        }}
                                    >
                                        <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                                            {overlayData['attributes']['mapsInfo']}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            paddingTop: '10px',
                                        }}
                                    >
                                        <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                                            Tel：+{overlayData['attributes']['phone']}
                                        </Typography>
                                    </Box>
                                </Box>
                            </OverlayViewF>)}
                        </GoogleMap>
                    ) : (
                        <></>
                    )}
                </Box>

                {/* body:grid */}

                <Box sx={{
                    width: '100%',
                    paddingTop: data !== null && data.length === 0 ? '0px' : '60px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingBottom: '12px',
                }}>
                    {data === null ?
                        (<Box>
                            <Grid container columnSpacing={isTablet ? 2 : 0} rowSpacing={6}>
                                {skeletonData.map((item, index) => skeletonItem(index))}
                            </Grid>
                        </Box>)
                        :
                        (data.length === 0 ? (<Box sx={{ paddingTop: '100px' }}>
                            <Empty description={<Typography>Oops! No result found.</Typography>}>
                                <Typography color={'#B2B2B2'}>Please try search options or filter that are available.</Typography>
                            </Empty>
                        </Box>) : (
                            <InfiniteScroll
                                dataLength={data.length}
                                next={loadMoreData}
                                hasMore={currentPage < pageCount ? true : false}
                                loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
                                endMessage={
                                    <Box sx={{
                                        paddingTop: '40px',
                                        paddingBottom: '20px',
                                        paddingLeft: '0px',
                                        paddingRight: '0px',
                                      }}>
                                        <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                                    </Box>
                                }
                                ref={scrollRef}
                            >
                                <Grid container rowSpacing={2} columnSpacing={isTablet ? 2 : 0}>
                                    {data.map((item, index) => (
                                        <Grid key={index} item xs={isTablet ? 6 : 12}>
                                            <Box onClick={() => updateCurrentId(data[index]['id'])}>
                                                <Card
                                                    style={{
                                                        borderRadius: '4px',
                                                        boxShadow: 'none',
                                                        border: 'none',
                                                        '&:hover': {
                                                            boxShadow: 'none'
                                                        }
                                                    }}
                                                >
                                                    <div dangerouslySetInnerHTML={{ __html: data[index]['attributes']['image'] }} style={{ minHeight: '150px', borderRadius: '4px' }} />
                                                </Card>

                                                <Box sx={{
                                                    paddingTop: '20px'
                                                }}>
                                                    <Typography fontSize={20} fontWeight={700} color={'#141F39'}>
                                                        {data[index]['attributes']['dearName']}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{
                                                    paddingTop: '6px'
                                                }}>
                                                    <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                                                        {data[index]['attributes']['mapsInfo']}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{
                                                    paddingTop: '6px'
                                                }}>
                                                    <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                                                        Tel：+{data[index]['attributes']['phone']}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </InfiniteScroll>))}
                </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppOurDealer
